// Helpers
import { to } from '../lib/helpers';

// Requests
import { sendOTPRequest , verifyOTPRequest, verifyOTPRequestCreateAccount} from '../backend/OTPRequests';
// Actions
import * as actions from '../reducers/OTP/OTPActions';

export const OTPMiddlewareListeners = {
  [actions.OTP_SEND_CODE_REQUESTED]: async ({ dispatch }, { payload }) => {
    const [{ response, body }] = await to(dispatch(sendOTPRequest(payload)));

    if (response.status === 200)
      dispatch({
        type: actions.OTP_SEND_CODE_SUCCESS,
        payload: { data: payload, headers: response.headersObject },
      });

    return Promise.resolve({ response, body });
  },
  [actions.OTP_VERIFY_CODE_REQUESTED]: async ({ dispatch }, action) => {
    const { userEmail, code, headers } = action.payload;
    const [{ response, body }] = await to(
      dispatch(verifyOTPRequest({ userEmail, code, headers }))
    );

    if (response.status === 200)
      dispatch({ type: actions.OTP_VERIFY_CODE_SUCCESS, payload: code });

    return Promise.resolve({ response, body });
  },
  [actions.OTP_VERIFY_CODE_REQUESTED_CREATE_ACCOUNT]: async (
    { dispatch },
    { payload }
  ) => {
    const { userPhone, userEmail, code, headers } = payload;
    const [{ response, body }] = await to(
      dispatch(
        verifyOTPRequestCreateAccount({
          userPhone,
          userEmail,
          code,
          headers,
        })
      )
    );

    if (response.status === 200) {
      dispatch({ type: actions.OTP_VERIFY_CODE_SUCCESS, payload: code });
    }

    return Promise.resolve({ response, body });
  },
};

const OTPMiddleware = store => next => action => {
  if (OTPMiddlewareListeners[action.type])
    return OTPMiddlewareListeners[action.type](store, action);
  return next(action);
};

export default OTPMiddleware;
